
const stepDuration = 1000;

const bouldaActiveAnimation = {
  animation: [
  ],
};

export default bouldaActiveAnimation